/* import "three/examples/js/QuickHull";
import "three/examples/js/geometries/ConvexGeometry"; */
import {v3} from 'oc-threejs/short3';
import ConvexUvBufferGeometry from "oc-threejs/geometries/ConvexUvBufferGeometry";
import alphaShape from "alpha-shape";

/**
 * Kopiert von ConvexBufferGeometry und erweitert um uv-Mapping
 */
export default class BrettBufferGeometry extends THREE.BufferGeometry {
    constructor(brett) {
        super();

        // buffers
        const vertices = [];
        const normals = [];
        const uvs = [];

        const basis = brett.getBasis();
        const xAxis = v3();
        const yAxis = v3();
        const zAxis = v3();
        basis.extractBasis(xAxis, yAxis, zAxis);
        const inverseBrettBasis = new THREE.Matrix4().getInverse(basis);
        const uvBoundingBox = new THREE.Box3().setFromPoints(brett.vertices.map(v => v.clone().applyMatrix4(inverseBrettBasis)));

        // UV-Verlauf der Texturen in der Ebene zur jeweiligen Brett-Basis-Normalen
        const planeBasisUV_X = ['y', 'z'];
        const planeBasisUV_Y = ['z', 'x'];
        const planeBasisUV_Z = ['y', 'x'];

        const faces = this.getFacesFromPoints(brett.vertices,brett.concave);

        faces.forEach(face => {

            // Ermittlung der planeBasisUV anhand der am besten übereinstimmenden Basis-Achse
            const xAxisDot = Math.abs(face.normal.dot(xAxis));
            const yAxisDot = Math.abs(face.normal.dot(yAxis));
            const zAxisDot = Math.abs(face.normal.dot(zAxis));
            let planeBasisUV;
            if (yAxisDot < xAxisDot) {
                if (zAxisDot < xAxisDot) {
                    planeBasisUV = planeBasisUV_X;
                } else {
                    planeBasisUV = planeBasisUV_Z;
                }
            } else {
                if (zAxisDot < yAxisDot) {
                    planeBasisUV = planeBasisUV_Y;
                } else {
                    planeBasisUV = planeBasisUV_Z;
                }
            }

            // we move along a doubly-connected edge list to access all face points (see HalfEdge docs)
            face.points.forEach(point=>{
                vertices.push(point.x, point.y, point.z);
                normals.push(face.normal.x, face.normal.y, face.normal.z);

                const pointUV = point.clone().applyMatrix4(inverseBrettBasis);
                const uv = pointUV.sub(uvBoundingBox.min);
                uvs.push(uv[planeBasisUV[0]], uv[planeBasisUV[1]]);
            });
        });

        // build geometry
        this.addAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        this.addAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));
        this.addAttribute('uv', new THREE.Float32BufferAttribute(uvs, 2));
    }

    getFacesFromPoints(vertices,concave) {
        if (concave) {
            const v01 = v3();
            const v02 = v3();
            const vertexInput = vertices.map(v=>v.toArray());
            const faceVertexIndizes = alphaShape(0.001,vertexInput);
            const faces = faceVertexIndizes.map(fvi=>{
                const vs = fvi.map(i=>vertices[i]);
                v01.subVectors( vs[1], vs[0] );
                v02.subVectors( vs[2], vs[0] );
                v02.cross( v01 );
                v02.normalize();
                return {points:vs,normal:v02.clone()};
            });
            console.log(faces);
            return faces;
        }
        return new THREE.ConvexHull().setFromPoints(vertices).faces.map(face=>{
            const a = face.edge.tail().point;
            const b = face.edge.head().point;
            const c = face.edge.next.head().point;
            return {points:[a,b,c],normal:face.normal};
        });
    }
}

